import { RouteConfig } from 'vue-router';
import Privacy from './privacy.vue';

export const MswPrivacyRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'privacy',
  component: Privacy,
};
